import Vue from 'vue';
import BaseProxy from './base-proxy';

/**
 * Class DirectoryProxy
 */
class DirectoryProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/invoice-robotics-api/api', parameters);
  }

  /**
   * @returns {Promise}
   */
  getDirTree() {
    return this.submit('get', `${this.endpoint}/get-structure`);
  }

  /**
   * @returns {Promise}
   * @param payload
   */
  createDir(payload) {
    const toast = {
      success: Vue.i18n.t('directory.createSuccess'),
      error: Vue.i18n.t('directory.createError'),
    };
    if (!payload.parent_id) {
      payload.parent_id = 0;
    }
    return this.submit('post', `${this.endpoint}/create-new-dir`, payload, { toast });
  }

  /**
   * @returns {Promise}
   * @param payload
   */
  updateDirTree(payload) {
    const toast = {
      success: Vue.i18n.t('app.updateSuccess'),
      error: Vue.i18n.t('app.updateError'),
    };
    return this.submit('post', `${this.endpoint}/update-whole-dirs`, payload, { toast });
  }

  /**
   * @returns {Promise}
   * @param payload
   */
  updateDirStructure(payload) {
    return this.submit('post', `${this.endpoint}/update-structure`, { structure: payload });
  }

  /**
   * @returns {Promise}
   * @param payload
  */
  connectDirTiktok(payload) {
    return this.submit('get', `${this.endpoint}/integrate/tiktok/initiate-tiktok-auth`, { structure: payload })
      .then(data => ({
        success: true,
        data
      }));
  }

}

export default DirectoryProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/directory-proxy.js